<template>
  <v-row class="justify-end align-right">
    <v-col
      class="align-right"
      cols="12"
    >
      <v-card
        height="300px"
        class="overflow-hidden my-6 mx-8 bg-black"
      >
        <video
          class="user-video"
          ref="video"
          autoplay
          playsinline
          muted
        ></video>
        <audio
          ref="audio"
          autoplay
        ></audio>
        <AudioLevel
          class="user-audiolvl"
          :track="selected.audio"
        />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { createLocalVideoTrack, createLocalAudioTrack } from "twilio-video"
import AudioLevel from "@/components/video-meeting/utils/AudioLevel.vue"
export default {
  name: "MediaSettings",
  components: { AudioLevel },
  props: {
    localTracks: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      selected: {
        audio: null,
        video: null
      }
    }
  },
  mounted() {
    this.preview()
  },
  methods: {
    async preview() {
      const localVideoTrack = await createLocalVideoTrack()
      const localAudioTrack = await createLocalAudioTrack()

      localVideoTrack.attach(this.$refs.video)
      localAudioTrack.attach(this.$refs.audio)
      this.selected.audio = localAudioTrack

      this.$emit("update-tracks", [localVideoTrack, localAudioTrack])
    }
  }
}
</script>

<style scoped>
.bg-black {
  background-color: black !important;
}
.user-audiolvl {
  position: absolute;
  right: 17px;
  top: 15px;
}
.user-video {
  width: 100%;
  height: 100%;
}
</style>
